import axios from 'axios'

const state = {
    timesheetForModification: {},
    isLoadingTable: false,
    showDeleteModal: false
}

const mutations = {
    getPaginatedTimeSheets(state, payload) {
        state.isLoadingTable = true
        axios.get(`api/timesheetformodifications/page=${payload.page}&pageSize=${payload.pageSize}/byStatus=${payload.status}/${payload.query}`)
            .then(response => {
                state.timesheetForModification = response.data
            }).catch(error => {
                // eslint-disable-next-line no-console
                console.log(error);
            }).then(() => {
                state.isLoadingTable = false
            })
    }
}

const actions = {
    getPaginatedTimeSheets({
        commit
    }, payload) {
        commit("getPaginatedTimeSheets", payload)
    }
}

export default{
    namespaced: true,
    state, mutations,
    actions
}